import { Button, Center, Stack } from '@mantine/core'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { RouterPath } from '@/router/paths'

type ErrorWithBackToLoginProps = {
  errorMessage: ReactNode
}

export const ErrorWithBackToLogin = ({
  errorMessage
}: ErrorWithBackToLoginProps) => {
  return (
    <Stack>
      <PlatformAlert variant="error">{errorMessage}</PlatformAlert>

      <Center>
        <Button component={Link} to={RouterPath.login}>
          <FormattedMessage id="auth.backToLogin" />
        </Button>
      </Center>
    </Stack>
  )
}
